// Copyright (c) 2016 Deere & Company

import {SERVICE_PART_FAILURE, UPTIME_ASSURANCE} from '../constants';
import {isNotEmpty, isNotNull, isNumberInputValid, isRepairDateAfterFailureDate, validateUseAmountIfPinExists} from '../../shared/services/claim-shared-helper';
import SpaClaim from '@deere/cps-it.warranty-model-factory/lib/claim-special-allowance';
import {removeEmptyRows} from '../../shared/services/empty-claim-rows';

const hasAtLeastOneClaimItem = claim => claim.parts.length || claim.labor.length || claim.otherCredits.length;
const isNotRequiredForServicePartFailure = (claim, value) => claim.specialAllowanceType.key === SERVICE_PART_FAILURE || isNotEmpty(value);

const hasComplaintCauseCorrection = complaintCauseCorrection => [
    isNotEmpty(complaintCauseCorrection.causeOfComplaining),
    isNotEmpty(complaintCauseCorrection.howWasComplaintCorrected),
    isNotEmpty(complaintCauseCorrection.operatorsComplaint)
].every(rule => rule);

export const canShowAllSections = (claimNumber, isValidClaim) => isValidClaim || isNotEmpty(claimNumber);

const isServicePartFailureValid = claim => (claim.specialAllowanceType.key !== SERVICE_PART_FAILURE) || [
    isNotEmpty(claim.previousInvoiceNumber),
    isNumberInputValid(claim.retailInstallDate)
].every(rule => rule);

const canFailurePartValid = claim => (claim.specialAllowanceType.key === UPTIME_ASSURANCE) || [
    isNotEmpty(claim.failureInfo.failurePartNumber)
].every(rule => rule);

const isRepairDateValid = claim => (claim.specialAllowanceType.key === UPTIME_ASSURANCE) ? true : [
    isRepairDateAfterFailureDate(claim.failureInfo.repairDate, claim.failureInfo.failureDate),
    isNumberInputValid(claim.failureInfo.repairDate)

].every(rule => rule);

export const isValidClaim = (claim, allowedUnitsLength) => [
    canFailurePartValid(claim),
    isNotEmpty(claim.pin) || isNotEmpty(claim.model) && isNotEmpty(claim.serialNumber),
    validateUseAmountIfPinExists(claim, allowedUnitsLength),
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.referenceInfo.ownershipStatus.key),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isNotEmpty(claim.specialAllowanceType.key),
    isNumberInputValid(claim.failureInfo.failureDate),
    isServicePartFailureValid(claim),
    isRepairDateValid(claim)
].every(rule => rule);

export const saveValidate = claim => [
    isValidClaim(claim),
    isNotEmpty(claim.additionalFailureInfo.failureMode.key),
    isNotEmpty(claim.additionalFailureInfo.failureArea),
    isNotEmpty(claim.additionalFailureInfo.downtime.key),
    hasComplaintCauseCorrection(claim.complaintCauseCommentsBasis),
    hasAtLeastOneClaimItem(removeEmptyRows(claim, SpaClaim))
].every(rule => rule);

export const mapFormValidation = (property, value, claim) => {

    const boundIsNotRequiredForServicePartFailure = isNotRequiredForServicePartFailure.bind(null, claim);
    const map = {
        basisForSettlement: isNotEmpty,
        companyContribution: isNotNull,
        complaintCause: isNotEmpty,
        complaintCorrection: isNotEmpty,
        customerContribution: isNotEmpty,
        dealerContribution: isNotEmpty,
        downtime: isNotEmpty,
        failureArea: isNotEmpty,
        failureDate: isNotNull,
        failureMode: isNotEmpty,
        failurePart: isNotEmpty,
        model: isNotEmpty,
        operatorsComplaint: isNotEmpty,
        ownershipStatus: isNotEmpty,
        pin: boundIsNotRequiredForServicePartFailure,
        previousInvoiceNumber: isNotEmpty,
        repairDate: isNotNull,
        responsibleAccount: isNotEmpty,
        retailInstallDate: isNumberInputValid,
        serialNumber: isNotEmpty,
        spaType: isNotEmpty,
        useAmount: isNotEmpty,
        useAmountUnit: isNotEmpty,
        workOrderOne: isNotEmpty
    };

    return map[property](value);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) => selectedAction === 'VALIDATE' ?
    !validationFailed && !currentPageValidity :
    false;

export const isValidationRequiredForClaimFied = (specialAllowanceType, validationStatus) =>
    specialAllowanceType.key === UPTIME_ASSURANCE ?
        true :
        validationStatus;

export const getFieldClassNameForClaimFied = (fieldClass, specialAllowanceType, claimRequiredClass) => {

    const fieldClassName = `${fieldClass} ${claimRequiredClass}`;

    return specialAllowanceType.key === UPTIME_ASSURANCE ?
        `${fieldClass}` :
        fieldClassName;

};




// WEBPACK FOOTER //
// ./src/claim/spa/services/claim-validation-helper.js